document.addEventListener("DOMContentLoaded", () => {
    const searchInput = document.getElementById('searchInput')
    if (!searchInput) return

    const dropdownOptions = document.getElementById('dropdownOptions'),
          contentPart = document.querySelector('.content-part'),
          options = Array.from(document.querySelectorAll('.dropdown-item'), element => [element.textContent, element.id])
    let   orderedCheckedValues = [],
          checkedValues = []

    function renderOptions(filteredOptions) {
        let checkById = []
        if (orderedCheckedValues.length) {
            checkById = orderedCheckedValues.map(id => id[1])
        }
        dropdownOptions.innerHTML = '' // Очистить старые результаты
        filteredOptions.forEach(option => {
            const label = document.createElement('label')

            label.innerHTML = `<input form="work_execution" name="service[]" class="dropdown-checkbox" type="checkbox" value="${option[1]}" ${checkById.includes(option[1]) ? 'checked' : ''}>${option[0]}`
            dropdownOptions.appendChild(label)
        })
        if (!filteredOptions.length) {
            dropdownOptions.innerHTML = '<div>Нет совпадений</div>'
        }
    }

    searchInput.addEventListener('focus', ({target}) => {
        contentPart.innerHTML = ''
        dropdownOptions.inert = true
        dropdownOptions.show()
        dropdownOptions.inert = false
        target.focus()
        renderOptions(options)
    })
    searchInput.addEventListener('input', ({target}) => {
        const filter = target.value.toLowerCase(),
              filteredOptions = options.filter(option => option[0].toLowerCase().includes(filter))

        renderOptions(filteredOptions)
    })
// Закрыть дропдаун при клике вне его
    document.addEventListener('click', ({target}) => {
        if (target.tagName !== 'INPUT' && target.tagName !== 'LABEL') {
            searchInput.value = ''
            let content = orderedCheckedValues
            if (!dropdownOptions.hasAttribute('open')) {
                content = []
            }
            dropdownOptions.removeAttribute('open')
            content.forEach(value => {
                contentPart.innerHTML +=
                    `<div class="uncheck-action">
                        <div class="side-left">
                            <span id="${value[1]}">${value[0]}</span>
                        </div>
                        <div class="side-right">
                            <div class="circle-red">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>`
            })
        }
    })

    dropdownOptions.addEventListener('change', ({target}) => {
        const serviceId = target.value,
              serviceName = target.nextSibling.textContent

        if (target.checked) {
            checkedValues.push([serviceName, serviceId])
        } else {
            const index = checkedValues.findIndex(element => element[1] === serviceId)
            checkedValues.splice(index, 1)
        }
        //сортируем как в искомом списке
        orderedCheckedValues = options.map(id => checkedValues.find(item => item[1] === id[1])).filter(Boolean)
    })

    contentPart.addEventListener('click', ({target}) => {
        if (target.classList.contains('fa-times') || target.classList.contains('circle-red')) {
            const serviceId = target.closest('.side-right').previousElementSibling.firstElementChild.id,
                  index = orderedCheckedValues.findIndex(element => element[1] === serviceId)

            target.closest('.uncheck-action').remove()
            orderedCheckedValues.splice(index, 1)
            checkedValues.splice(index, 1)
        }
    })
    //предупреждение при попытке отправить пустые данные.
    document.querySelector('form').addEventListener('submit', function(event) {
        if (!checkedValues.length) {
            alert('Пожалуйста, выберите работу перед отправкой.');
            $('form').data('skip-loader', true);
            event.preventDefault();
            return;
        }

        const startDate = document.querySelector('#start-date').value;
        const endDate = document.querySelector('#end-date').value;
        const detailedFiles = document.querySelector('input[name="detailed_images[]"]').files;
        const commonFiles = document.querySelector('input[name="common_images[]"]').files;

        if (!startDate) {
            alert('Пожалуйста, введите дату начала работ');
            $('form').data('skip-loader', true);
            event.preventDefault();
            return;
        }

        if (!endDate) {
            alert('Пожалуйста, введите дату завершения работ');
            $('form').data('skip-loader', true);
            event.preventDefault();
            return;
        }

        if (detailedFiles.length === 0) {
            alert('Пожалуйста, загрузите детальные фото');
            $('form').data('skip-loader', true);
            event.preventDefault();
            return;
        }

        if (commonFiles.length === 0) {
            alert('Пожалуйста, загрузите фото общего плана');
            $('form').data('skip-loader', true);
            event.preventDefault();
            return;
        }

        $('form').data('skip-loader', false);
    });
});